var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNigeria(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4029_4134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24.6895C19.1274 24.6895 24.5 19.3169 24.5 12.6895C24.5 6.06204 19.1274 0.689453 12.5 0.689453C5.87258 0.689453 0.5 6.06204 0.5 12.6895C0.5 19.3169 5.87258 24.6895 12.5 24.6895Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.6894C0.5 17.849 3.7565 22.2474 8.32611 23.943V1.43579C3.7565 3.13126 0.5 7.52982 0.5 12.6894Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4999 12.6894C24.4999 7.52982 21.2434 3.13126 16.6738 1.43579V23.9431C21.2434 22.2474 24.4999 17.849 24.4999 12.6894Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4029_4134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.689453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeria);
export default __webpack_public_path__ + "static/media/nigeria.586ad3cc3368eac9d6fdba0477429d27.svg";
export { ForwardRef as ReactComponent };